import React from 'react';
import { MoonIcon, SunIcon } from 'lucide-react';
const columns = [{
  id: 'day',
  label: 'Día',
  state: 'Digestión activa',
  points: ['Más movimiento', 'Mayor demanda energética', 'Procesa alimentos variados'],
  icon: SunIcon,
  tone: 'bg-paper text-ink',
  iconTone: 'bg-[#f6d98b] text-ink',
  dot: 'bg-[#d9a93a]'
}, {
  id: 'night',
  label: 'Noche',
  state: 'Digestión en modo descanso',
  points: ['Baja revoluciones', 'Prepara el sueño y repara', 'Necesita comidas simples'],
  icon: MoonIcon,
  tone: 'bg-[#3a2e2a] text-[#fbeee8]',
  iconTone: 'bg-brand-blush text-ink',
  dot: 'bg-brand-pink'
}];
export function DayNightGraphic() {
  return <figure className="my-7" data-id="element-146" data-mp="5rey2863yuxx">
      <div className="grid overflow-hidden rounded-sm border border-brand-blush sm:grid-cols-2" data-id="element-147" data-mp="5q3sc2t3rd46">
        {columns.map(column => {
        const Icon = column.icon;
        return <div key={column.id} className={`p-5 sm:p-6 ${column.tone}`} data-id="element-148" data-mp="2qg31gflvvs8d">
              <div className="flex items-center gap-3" data-id="element-149" data-mp="2smbd71m3agwb">
                <span className={`flex h-10 w-10 items-center justify-center rounded-full ${column.iconTone}`} data-id="element-150" data-mp="2skrwxb0fo5uj">
                  <Icon className="h-5 w-5" aria-hidden="true" data-id="element-151" data-mp="2jlwp5uhqqnp4" />
                </span>
                <div data-id="element-152" data-mp="2jo95623xunzj">
                  <p className="font-display text-xl font-bold leading-none" data-id="element-153" data-mp="2nn885h640aoc">{column.label}</p>
                  <p className="mt-1 font-sans text-[0.8rem] font-medium opacity-80" data-id="element-154" data-mp="29wd7ut9of1wd">{column.state}</p>
                </div>
              </div>
              <ul className="mt-4 space-y-1.5 font-sans text-[0.85rem]" data-id="element-155" data-mp="2enlg3lz9sh7y">
                {column.points.map(point => <li key={point} className="flex items-center gap-2.5" data-id="element-156" data-mp="1zvuf1904wb2b">
                    <span className={`h-1.5 w-1.5 shrink-0 rounded-full ${column.dot}`} aria-hidden="true" data-id="element-157" data-mp="24xs6gqiouc6c" />
                    {point}
                  </li>)}
              </ul>
            </div>;
      })}
      </div>
      <figcaption className="mt-2 font-sans text-xs leading-relaxed text-ink-muted" data-id="element-158" data-mp="1g3oo2oiqn7t">
        Durante el día la digestión está activa; por la noche el organismo cambia de prioridad.
        Gráfico ilustrativo.
      </figcaption>
    </figure>;
}